import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormField } from '../../entities/form.entity';

@Component({
  selector: 'app-field-yesno',
  templateUrl: './field-yesno.component.html',
  styleUrls: ['./field-yesno.component.scss']
})
export class FieldYesnoComponent implements OnInit {
  @Input() field!: FormField;
  @Input() disabled: boolean = false;
  @Output() onFieldChange = new EventEmitter<{
    fieldId: string;
    isValid: boolean;
    value: string;
  }>();

  ngOnInit(): void {
    if (this.field.value === undefined || this.field.value === null) {
      this.field.value = '';
    }
  }

  handleValueChange(value: string): void {
    if (this.field.value !== value) {
      this.field.value = value;
      this.emitFieldChange();
    }
  }

  emitFieldChange(): void {
    this.onFieldChange.emit({
      fieldId: this.field.fieldId,
      isValid: this.validateField(this.field.value),
      value: this.field.value
    });
  }

  validateField(value: string): boolean {
    return typeof value === 'string' && (value === 'yes' || value === 'no');
  }
}